import React, {useState, useEffect} from 'react';
// import { Link } from 'react-router-dom';
// import FacebookIcon from 'mdi-react/FacebookIcon';
// import GooglePlusIcon from 'mdi-react/GooglePlusIcon';
import LogInForm from './components/LogInForm';
import { signin } from "../../redux/middlewares/authMIddleware";
import { connect } from 'react-redux';



const LogIn = (props) =>{ 
  const [error, setError] = useState("");

  useEffect(() => {
    setError(props.error)
  }, [props.error])

  const submitHandler = (values) => {
    console.log({values});
    setError("")
    const { email, password } = values
    props.signin(email, password, () => props.history.push("/"));
  }


  return(
  <div className="account">
    <div className="account__wrapper">
      <div className="account__card">
        <div style={error ? {padding:'1rem', width:'100%', border:'1px solid red', marginBottom:'10px'} : {display:'none'}}>
            <h4 className="account__subhead subhead" style={{color:'red'}}> {error} </h4>
        </div>
        <div className="account__head">
          <h3 className="account__title">Welcome to
            <span className="account__logo"> <img src={require("../../assets/images/heyremote-logo.png")} style={{width:'150px', height:'35px', marginBottom:'14px'}} width='150' height='150' />
            </span>
          </h3>
          <h4 className="account__subhead subhead">Start your business easily</h4>
        </div>
        <LogInForm onSubmit = {submitHandler} />
        {/* <div className="account__or">
          <p>Or Easily Using</p>
        </div>
        <div className="account__social">
          <Link
            className="account__social-btn account__social-btn--facebook"
            to="/pages/one"
          ><FacebookIcon />
          </Link>
          <Link
            className="account__social-btn account__social-btn--google"
            to="/pages/one"
          ><GooglePlusIcon />
          </Link>
        </div> */}
      </div>
    </div>
  </div>
);}


const mapStateToProps = (state) => {
  return{
    error: state.authReducer.error 
  }
}

export default connect(mapStateToProps,{signin})(LogIn);

// if you want to add select, date-picker and time-picker in your app you need to uncomment the first
// four lines in /scss/components/form.scss to add styles
